import { useSelector } from "react-redux";
import RechargeView from "./view";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { PAYMENT_TYPE } from "@/redux/ducks/customer";
import { getFormattedCart } from "@/utils/functions";
import { useSingleCardBrand } from "@/hooks/useCardBrands";
import { getMaskedCardNumber } from "@/utils/transform";
import { SavedCard } from "./Models";


export default function Recharge() {
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const { brand } = useSingleCardBrand(customer?.account?.card?.id || "");

  const cart = customer?.cart?.filter(item => item.checked) ?? [];
  const debts = customer?.debts ?? [];
  const { total, filteredItems } = getFormattedCart({ debts, cart });

  const plate = customer?.selectedVehicles?.length
    ? customer.selectedVehicles.join(", ")
    : customer?.vehicles?.[0]?.plate ?? "";

  const passagesTotal = filteredItems?.reduce(
    (sum, item) => sum + (item?.original?.valorPassagem ?? 0), 0
  ) ?? 0;

  const finesTotal = filteredItems?.reduce(
    (sum, item) => sum + (item?.original?.vlMulta ?? 0), 0
  ) ?? 0;

  const savedCard: SavedCard | null = customer?.account?.card?.id
    ? {
        brand: brand?.descricaoBandeira?.toLowerCase() || "",
        number: getMaskedCardNumber(customer?.account?.card?.cardNumber || ""),
      }
    : null;

  const goBack = () => navigate("/");

  const goToCard = () => {
    if (customer?.account?.paymentType === PAYMENT_TYPE.IS_CARD) {
      navigate('/payment/card');
      return;
    }
    navigate('/payment/creditCard');
  };

  const goToPix = () => navigate('/payment/pix');
  const goToNewCard = () => navigate('/payment/creditCard');

  return (
    <RechargeView
      goBack={goBack}
      goToCard={goToCard}
      goToPix={goToPix}
      goToNewCard={goToNewCard}
      plate={plate}
      total={total}
      passagesTotal={passagesTotal}
      finesTotal={finesTotal}
      savedCard={savedCard}
    />
  );
}
